// extracted by mini-css-extract-plugin
module.exports = {"job-board-filter":"JobsFilters_job-board-filter__MOJM_","filter-wrapper":"JobsFilters_filter-wrapper__ioAL4"};